module.exports = ".full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/hojadeseguimiento/anamnesis/anamnesisdetalle/anamnesisdetalle.component.scss
// module id = ./src/app/consulta/hojadeseguimiento/anamnesis/anamnesisdetalle/anamnesisdetalle.component.scss
// module chunks = main